import { Injectable } from '@angular/core';
import { ModalInfos } from '../../models/modal/modal-infos';
import { Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { STORAGE_KEYS } from '../../enums/commission';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalSubject = new Subject<ModalInfos>();
  private modalCloseSub: Subject<void> = new Subject<void>();
  constructor(private authService: AuthService) {}

  showModal(modalInfos: ModalInfos): void {
    this.modalSubject.next(modalInfos);
  }

  closeModal(): void {
    this.modalCloseSub.next();
  }

  showError(httpErrorResp: HttpErrorResponse): void {
    this.modalSubject.next(this.getModalInfosFromCode(httpErrorResp));
  }

  getSubject(): Subject<ModalInfos> {
    return this.modalSubject;
  }

  getCloseSubject(): Subject<void> {
    return this.modalCloseSub;
  }

  getModalInfosFromCode(httpErrorResp: HttpErrorResponse): ModalInfos {
    const status: string = httpErrorResp.status.toString();

    switch (status) {
      case '401':
        this.authService.isLogged = false;
        localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        return new ModalInfos(
          'Attenzione',
          ' La sessione è scaduta, si prega di effettuare nuovamente il login',
          () => {
            this.authService.initiateLogin();
          },
          'pi pi-exclamation-triangle'
        );
      case '403':
        this.authService.isLogged = false;
        localStorage.removeItem(STORAGE_KEYS.ID_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        return new ModalInfos(
          'Attenzione',
          httpErrorResp.error.message || 'Operazione non consentita',
          () => {
            window.open('/', '_self');
          },
          'pi pi-exclamation-triangle'
        );
      default:
        return new ModalInfos(
          'Attenzione',
          httpErrorResp.error.message || 'Errore generico',
          () => {
            window.open('/', '_self');
          },
          'pi pi-exclamation-triangle'
        );
    }
  }
}
